import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CertificadoService {
  private certificadoSubject = new BehaviorSubject<string>(null);
  private mostrarCertificadoSubject = new BehaviorSubject<boolean>(false);

  // Observable para o componente se inscrever
  certificado$ = this.certificadoSubject.asObservable();
  mostrarCertificado$ = this.mostrarCertificadoSubject.asObservable();


  // Método para atualizar a data do certificado
  atualizarCertificado(data: string,acitve: boolean) {
    this.certificadoSubject.next(data);
    this.mostrarCertificadoSubject.next(acitve);
  }
}
